@let boundData = bound();
@let cityNames = cityNameByLocationCode();
@let tails = tailNames();

<section class="ps-small-x ps-small-t" [attr.data-testid]="'bound-section-' + boundData.id">
  <div class="flex flex--space-between">
    <h3 class="font-heading-5 font-title-small">
      {{ cityNames[boundData.departure.locationCode] }}
      <fcom-icon [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL"></fcom-icon>
      {{ cityNames[boundData.arrival.locationCode] }}
    </h3>
    <fcom-icon-button
      [icon]="{ name: SvgLibraryIcon.INFO }"
      [size]="IconButtonSize.SMALL"
      [aria]="{
        label: 'shoppingCart.viewAllFlightDetailsAria' | finLocalization,
      }"
      (clickBtn)="openItineraryDetails.emit()"
    ></fcom-icon-button>
  </div>
  <span class="font-body-1 font-body-medium">{{ boundData.departure.dateTime | finDateFormat: 'FULL_NO_YEAR' }}</span>
  <span class="font-body-1 bold-type font-body-medium-bold">
    {{ boundData.departure.dateTime | finTime }} - {{ boundData.arrival.dateTime | finTime }}
  </span>
  <div class="flex">
    @if (tails.length) {
      <div class="flex--nogrow flex ms-xxsmall-b" aria-hidden="true">
        @for (tail of tails; track tail; let first = $first) {
          <div class="flex--nogrow tail {{ tail }}" [class.minus-margin]="!first"></div>
        }
      </div>
    }
    @if (boundData.uniqueAirlineNames.length) {
      <div class="flex--nogrow overflow-hidden font-body-2 font-body-small">
        <span class="is-vishidden"> {{ 'bookingSummary.operatedBy' | finLocalization }} </span>
        {{ boundData.uniqueAirlineNames.join(', ') }}
      </div>
    }
  </div>
  <div class="font-body-1 ms-xsmall-y flex flex--middle font-body-medium" data-testid="fare-family-info">
    <span class="bold-type nowrap">{{ passengerCount() }} x</span>
    <fcom-icon [name]="SvgLibraryIcon.RESERVATION" class="icon-medium ms-xxsmall-l flex--shrink0"></fcom-icon>
    <fcom-link
      class="ms-xxsmall-l nowrap overflow-hidden"
      data-testid="fare-family-link"
      [aria]="{ label: 'shoppingCart.viewAllTicketDetailsAria' | finLocalization }"
      [truncate]="true"
      (beforeNavigation)="openFareFamilyDetails.emit()"
      >{{ boundData.fareFamily?.name }}</fcom-link
    >

    @if (price()) {
      <div class="flex-1 flex flex--end ms-small-l nowrap">
        <span class="font-body-1 font-body-medium" data-testid="bound-total-price">
          {{ price() | finPrice }}
        </span>
      </div>
    }
  </div>
  <div class="ticket-benefits font-body-1 ps-large-l font-body-medium">
    @for (benefit of benefits(); track $index) {
      <div class="flex flex--space-between ps-xsmall-b">
        <span class="truncate overflow-hidden">
          @if (benefit.title) {
            @if (benefit.count) {
              {{ benefit.count + ' x ' }}
            }
            {{ benefit.title }}
          } @else if (benefit.titleKey) {
            {{ benefit.titleKey | finLocalization: { amount: benefit.count } }}
          }
        </span>
      </div>
    }
  </div>
  <div class="font-body-1 font-body-medium">
    @for (group of productGroups(); track group.category) {
      <fin-shopping-cart-category-line
        [items]="group.items"
        [category]="group.category"
        [currencyCode]="currency()"
        [categoryTitle]="group.categoryTitle"
        [comboConstituentTitles]="group.comboConstituentTitles"
      />
    }
  </div>
  <div class="separator ps-xxsmall-y border-bottom-dashed"></div>
</section>
